import React, { useState, useEffect } from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import { useAppData } from '../../../../../context/AppDataContext';
import TaskForm from '../components/TaskForm';
import TaskListView from '../components/TaskListView';
import { useAuth } from '../../../../../context/AuthContext';
import TaskFilterToolBar from '../hook/TaskFilterToolBar';
import { useTaskFilters } from '../hook/useTaskFilter';
import TaskActivityList from '../components/TaskActivityList';
import TaskCalendarView from '../components/TaskCalendarView';
import { CalendarMonth, TableChart, ViewStream } from '@mui/icons-material';
import TaskCardListView from '../components/TaskCardListView';
import { Link } from 'react-router-dom';

function TaskDashboardPage() {
    const { taskList, getTaskList } = useAppData();
    const { authUser } = useAuth();

    const [selectedView,setSelectedView] = useState("card")

    const { 
        filteredList, activeFilter, isDropdownOpen, setIsDropdownOpen, handleFilterChange 
    } = useTaskFilters(taskList, authUser); // No third argument means all projects

    useEffect(() => { if (!taskList) getTaskList(); }, []);

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='row align-items-center mb-0'>
                            
                            <div className='col-6'>
                                <div className="btn-group" role="group">
                                    <button type="button" className={selectedView === "card" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("card")}  ><ViewStream/> </button>
                                    <button type="button" className={selectedView === "tabular" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("tabular")}  ><TableChart/> </button>
                                    <button type="button" className={selectedView === "calendar" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("calendar")}  ><CalendarMonth/></button>
                                </div>
                                <Link to="/task/archived" className=' ms-2 btn btn-outline-danger'>Show Archived Task List</Link>
                            </div>
                            <div className='col-6'>
                                <span className='float-end'><TaskForm callBack={getTaskList} /></span>
                            </div>
                            
                            
                        </div>
                        <div className='row mt-1'>
                            <TaskFilterToolBar 
                                activeFilter={activeFilter}
                                handleFilterChange={handleFilterChange}
                                isDropdownOpen={isDropdownOpen}
                                setIsDropdownOpen={setIsDropdownOpen}
                            />
                        </div>
                        <div className='row'>
                            <div className='col-md-12' style={{maxHeight:"80vh", overflow:"scroll" }}>
                                {selectedView === "tabular" && <TaskListView taskList={filteredList} callBack={getTaskList} /> }
                                {selectedView === "card" && <TaskCardListView taskList={filteredList} callBack={getTaskList} /> }
                                {selectedView === "calendar" && <TaskCalendarView taskList={filteredList} callBack={getTaskList} /> }
                            </div>
                        </div>
                        
                    </div>
                    <div className='col-md-4'>
                        <div className='card mt-2'>
                            <div className='p-2' >
                                <TaskActivityList />
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

export default TaskDashboardPage